<template>
  <div class="report-card-container">
    <div class="inner-container flex-con">
      <template v-for="(item, index) in reportList">
        <div :key="index" class="report-one">
          <div class="report-title">{{ item.name }}</div>
          <el-button type="primary" @click="goReport(item)"
            >了解详情 ></el-button
          >
          <img :src="item.imgurl" alt="" />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { queryFRList } from "@/api/report/report";
import { mapGetters } from "vuex";
export default {
  name: "reportExcel",
  data() {
    return {
      reportList: [],
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      let res = await queryFRList({ type: to.meta.type });
      vm.reportList = res.data.data.records;
    });
  },
  async mounted() {
    // let res = await queryFRList({ type:this.type });
    // this.reportList = res.data.data.records;
  },
  methods: {
    goReport(item) {
      let redirectUrl = encodeURIComponent(
        `${window.location.origin}/${item.url}&ssoToken=${this.userInfo.fanruan_ssoToken}`
      );
      this.$router.push({
        path: `/myiframe/urlPath?name=${item.name}&src=${redirectUrl}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.report-card-container{
    .flex-con{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
       
    }
    .inner-container{
        background: #ffff;
        padding: 25px;
        .report-one{
            width: 18%;
            // width: calc((100vw - 310px)*0.16);
            margin-right: 2%;
            // max-width: 250px;
            // max-height: 350px;
            height: calc((100vw - 310px)*0.16*1.4);
            background: #f2f7fc;
            border-radius: 5px;
            border-width: 1px;
            border-style: solid;
            border-color: rgba(233, 233, 233, 1);
            box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.05);
            padding: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            margin-bottom: 20px;
            // box-sizing: border-box;
            // &:nth-child(5n){
            //   margin-right: 0%;
            // }
            .report-title{
                font-size: 20px;
                font-family: '微软雅黑';
                font-weight: bold;
                color: #333333;
                line-height: 60px;                
            }
            img{
                width: calc((100% + 40px)*0.6);
            }
        }

  }
}

</style>
 